import { Job } from "./Job"

export const jobs: Job[] = [
  {
    active: true,
    slug: "20250401-part-time-full-remotework-programmer",
    title: "20250401-part-time-full-remotework-programmer.title",
    titleEng: "20250401-part-time-full-remotework-programmer.titleEng",
    employmentType: "PART_TIME",
    location: "TELECOMMUTE",
    tags: [
      "20250401-part-time-full-remotework-programmer.tags.1",
      "20250401-part-time-full-remotework-programmer.tags.2",
    ],
    salary: {
      currencyCode: "JPY",
      min: 1200,
      max: 3600,
      unit: "HOUR",
    },
    skill: {
      required: "20250401-part-time-full-remotework-programmer.skill.required",
      optional: "20250401-part-time-full-remotework-programmer.skill.optional",
      technologies: [
        "Ruby (Ruby on Rails)",
        "Python",
        "TypeScript",
        "Kotlin",
        "JavaScript",
        "Swift",
        "C#",
        "Java",
        "C",
        "AWS",
        "GitHub",
        "PivotalTracker",
        "Slack",
      ]
    },
    works: [
      "20250401-part-time-full-remotework-programmer.works.1",
      "20250401-part-time-full-remotework-programmer.works.2",
      "20250401-part-time-full-remotework-programmer.works.3",
      "20250401-part-time-full-remotework-programmer.works.4",
      "20250401-part-time-full-remotework-programmer.works.5",
      "20250401-part-time-full-remotework-programmer.works.6",
    ],
    description: "20250401-part-time-full-remotework-programmer.description",
    applicantLocationRequirements: {
      "@type": "Country",
      name: "JAPAN"
    },
  },

  {
    active: true,
    slug: "20250401-part-time-programmer",
    title: "20250401-part-time-programmer.title",
    titleEng: "20250401-part-time-programmer.titleEng",
    employmentType: "PART_TIME",
    location: "EITHER",
    tags: [
      "20250401-part-time-programmer.tags.1",
      "20250401-part-time-programmer.tags.2",
    ],
    salary: {
      currencyCode: "JPY",
      min: 1200,
      max: 3600,
      unit: "HOUR",
    },
    skill: {
      required: "20250401-part-time-programmer.skill.required",
      optional: "20250401-part-time-programmer.skill.optional",
      technologies: [
        "Ruby (Ruby on Rails)",
        "Python",
        "TypeScript",
        "Kotlin",
        "JavaScript",
        "Swift",
        "C#",
        "Java",
        "C",
        "AWS",
        "GitHub",
        "PivotalTracker",
        "Slack",
      ]
    },
    works: [
      "20250401-part-time-programmer.works.1",
      "20250401-part-time-programmer.works.2",
      "20250401-part-time-programmer.works.3",
      "20250401-part-time-programmer.works.4",
      "20250401-part-time-programmer.works.5",
      "20250401-part-time-programmer.works.6"
    ],
    description: "20250401-part-time-programmer.description",
    applicantLocationRequirements: {
      "@type": "Country",
      name: "JAPAN"
    },
  },
  {
    active: true,
    slug: "20211020-full-time-full-remotework-system-engineer",
    title: "20211020-full-time-full-remotework-system-engineer.title",
    titleEng: "20211020-full-time-full-remotework-system-engineer.titleEng",
    employmentType: "FULL_TIME",
    location: "COMMUTE",
    tags: [
      "20211020-full-time-full-remotework-system-engineer.tags.1",
      "20211020-full-time-full-remotework-system-engineer.tags.2",
    ],
    salary: {
      currencyCode: "JPY",
      min: 4500000,
      max: 11700000,
      unit: "YEAR",
    },
    skill: {
      required: "20211020-full-time-full-remotework-system-engineer.skill.required",
      optional: "20211020-full-time-full-remotework-system-engineer.skill.optional",
      technologies: [
      ]
    },
    works: [
      "20211020-full-time-full-remotework-system-engineer.works.1",
      "20211020-full-time-full-remotework-system-engineer.works.2",
      "20211020-full-time-full-remotework-system-engineer.works.3",
      "20211020-full-time-full-remotework-system-engineer.works.4",
      "20211020-full-time-full-remotework-system-engineer.works.5",
      "20211020-full-time-full-remotework-system-engineer.works.6"
    ],
    description: "20211020-full-time-full-remotework-system-engineer.description",
  },
  {
    active: true,
    slug: "20211020-full-time-project-manager",
    title: "20211020-full-time-project-manager.title",
    titleEng: "20211020-full-time-project-manager.titleEng",
    employmentType: "FULL_TIME",
    location: "COMMUTE",
    tags: [
      "20211020-full-time-project-manager.tags.1",
      "20211020-full-time-project-manager.tags.2",
    ],
    salary: {
      currencyCode: "JPY",
      min: 5000000,
      max: 11940000,
      unit: "YEAR",
    },
    skill: {
      required: "20211020-full-time-project-manager.skill.required",
      optional: "20211020-full-time-project-manager.skill.optional",
      technologies: [
        "GitHub",
        "Slack",
        "DevOps",
        "アジャイル開発",
        "スクラム開発",
      ]
    },
    works: [
      "20211020-full-time-project-manager.works.1",
      "20211020-full-time-project-manager.works.2",
    ],
    description: "20211020-full-time-project-manager.description",
  },
  {
    active: true,
    slug: "20250401-full-time-office-manager",
    title: "20250401-full-time-office-manager.title",
    titleEng: "20250401-full-time-office-manager.titleEng",
    employmentType: "FULL_TIME",
    location: "COMMUTE",
    tags: [
      "20250401-full-time-office-manager.tags.1",
      "20250401-full-time-office-manager.tags.2",
    ],
    salary: {
      currencyCode: "JPY",
      min: 3000000,
      max: 4500000,
      unit: "YEAR",
    },
    skill: {
      required: "20250401-full-time-office-manager.skill.required",
      optional: "20250401-full-time-office-manager.skill.optional",
      technologies: [
      ]
    },
    works: [
      "20250401-full-time-office-manager.works.1",
      "20250401-full-time-office-manager.works.2",
      "20250401-full-time-office-manager.works.3",
      "20250401-full-time-office-manager.works.4",
    ],
    description: "20250401-full-time-office-manager.description",
  },
  {
    active: true,
    slug: "20250401-full-time-accountant",
    title: "20250401-full-time-accountant.title",
    titleEng: "20250401-full-time-accountant.titleEng",
    employmentType: "FULL_TIME",
    location: "COMMUTE",
    tags: [
      "20250401-full-time-accountant.tags.1",
      "20250401-full-time-accountant.tags.2",
    ],
    salary: {
      currencyCode: "JPY",
      min: 4000000,
      max: 5000000,
      unit: "YEAR",
    },
    skill: {
      required: "20250401-full-time-accountant.skill.required",
      optional: "20250401-full-time-accountant.skill.optional",
      technologies: [
        "簿記",
        "会計",
        "税務",
        "経理",
        "財務",
        "監査",
      ]
    },
    works: [
      "20250401-full-time-accountant.works.1",
      "20250401-full-time-accountant.works.2",
      "20250401-full-time-accountant.works.3",
    ],
    description: "20250401-full-time-accountant.description",
  }
]
